<template>
  <v-chart :option="option" autoresize style="width:100%;height:260px;" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VChart from 'vue-echarts';
import { useChartTheme } from '@/composables/useChartTheme';

export interface ChargingBarSession {
  label: string;
  kwh: number;
}

const props = defineProps<{ sessions: ChargingBarSession[] }>();

const option = computed(() => {
  const C = useChartTheme();
  return {
    backgroundColor: C.paper,
    grid: { top: 16, bottom: 48, left: 40, right: 16 },
    tooltip: {
      trigger: 'axis',
      formatter: (p: { name: string; value: number }[]) =>
        `${p[0].name}<br/>${p[0].value.toFixed(1)} kWh`,
    },
    xAxis: {
      type: 'category',
      data: props.sessions.map(s => s.label),
      axisLabel: { color: C.muted, fontSize: 11, fontFamily: 'Inter', rotate: 30 },
      axisLine: { lineStyle: { color: C.line } },
      axisTick: { show: false },
    },
    yAxis: {
      type: 'value',
      name: 'kWh',
      nameTextStyle: { color: C.muted, fontSize: 11, fontFamily: 'Inter' },
      axisLabel: { color: C.muted, fontSize: 11, fontFamily: 'Inter' },
      splitLine: { lineStyle: { color: C.line } },
      axisLine: { show: false },
      axisTick: { show: false },
    },
    series: [{
      type: 'bar',
      data: props.sessions.map(s => s.kwh),
      barWidth: '60%',
      itemStyle: { color: C.accent, borderRadius: [4, 4, 0, 0] },
      label: {
        show: true,
        position: 'top',
        color: C.muted,
        fontSize: 10,
        fontFamily: 'Inter',
        formatter: (p: { value: number }) => p.value.toFixed(0),
      },
    }],
  };
});
</script>
